import Alpine from "alpinejs";
import Swiper from "swiper";
import { EffectFade, Navigation } from "swiper/modules";

Alpine.data('Timeline', () => ({
    milestoneSlider: null, 
    imageSwiper: null,
    currentSlide: 0,
    init(){
        this.timelineSwiper = new Swiper(this.$el.querySelector('.timelineSlider'), {
            spaceBetween: 0,
            slidesPerView: 'auto'
        });

        this.milestoneSlider = new Swiper(this.$el.querySelector('.milestoneSlider'), {
            modules: [Navigation],
            direction: 'vertical',
            slidesPerView: 'auto',
            updateOnWindowResize: true,
            touchReleaseOnEdges: true,
            allowTouchMove: false,
            navigation: {
                nextEl: this.$el.querySelector('.swiper-navigation-right'),
                prevEl: this.$el.querySelector('.swiper-navigation-left'),
            },
            breakpoints: {
                768: {
                    touchReleaseOnEdges: false,
                    slidesPerView: 1,
                    direction: 'horizontal',
                    autoHeight: true,
                }
            }
        })
        
        this.bindEvents();
    },
    bindEvents(){
        this.milestoneSlider.on('slideChange', () => {
            this.currentSlide = this.milestoneSlider.activeIndex;

            this.timelineSwiper.slideTo(this.currentSlide)
        })
    },
    setCurrent(index) {
        this.currentSlide = index;

        this.milestoneSlider.slideTo(index);


    }
}));